import {
  getKey,
  queryOptions,
} from '@booking-portal/api/queries/use-customer-portal-queries';
import { getAllLocations } from '@booking-portal/api/services/customer-portal-service';
import { queryClient } from '@booking-portal/plugins/vue-query-plugin';
import { navigationNames } from '@booking-portal/router/router-constants';
import { toNumber } from '@booking-portal/utils/data-utils';
import type { NavigationGuardWithThis } from 'vue-router';

export const hasSharedAccessGuard: NavigationGuardWithThis<unknown> = async (
  to,
  from,
  next
) => {
  const locationId = toNumber(to.params.locationId as string, undefined);

  if (locationId == null) {
    return next({ name: navigationNames.accountOverview });
  }

  try {
    const response = await queryClient.ensureQueryData({
      queryKey: getKey('locations'),
      queryFn: () => getAllLocations(),
      ...queryOptions,
    });
    const location = response.data?.find((l) => l.id === locationId);

    if (location?.showManageAccess) {
      next();
    } else {
      next({
        name: navigationNames.accountOverview,
        params: { locationId: String(locationId) },
      });
    }
  } catch {
    next({
      name: navigationNames.accountOverview,
      params: { locationId: String(locationId) },
    });
  }
};
